import * as  tokens from 'mondrian-tokens/dist/claro-tokens-latest.module';

const acessibilityYellow = "#fff333";
const acessibilityYellowHover = "#e6da30";
const fullBlack = "#000000";

const contrastBody = {
  backgroundColor: fullBlack,
};

const contrast = {
  general: {
      colors: {
          contrast: {
              "--theme-border-color--contrast--clickable": acessibilityYellow,
              "--theme-border-color--contrast": tokens.colorNeutralLightest,
              "--theme-background-color--contrast--clickable": acessibilityYellow,
              "--theme-background-color--contrast": fullBlack,
              "--theme-text--contrast--clickable": acessibilityYellow,
              "--theme-text--contrast": tokens.colorNeutralLightest
          },
          background: {
              "--theme-background-color--default": fullBlack,
              "--theme-background-color--primary": fullBlack,
              "--theme-background-color--primary-dark": fullBlack,
              "--theme-background-color--primary-darkest": fullBlack,
              "--theme-background-color--secondary": fullBlack,
              "--theme-background-color--light": fullBlack,
              "--theme-background-color--lightest": fullBlack,
              "--theme-background-color--medium": fullBlack,
              "--theme-background-color--dark": fullBlack,
              "--theme-background-color--darkest": fullBlack,
              "--theme-background-color--global": fullBlack,
          },
          text: {
              "--theme-text-color--default": tokens.colorNeutralLightest,
              "--theme-text-color--primary": tokens.colorNeutralLightest,
              "--theme-text-color--primary-inverse": tokens.colorNeutralLightest,
              "--theme-text-color--secondary": tokens.colorNeutralLightest,
              "--theme-text-color--light": tokens.colorNeutralLightest,
              "--theme-text-color--dark": tokens.colorNeutralLightest,
              "--theme-text-color--inverse": tokens.colorNeutralLightest,
              "--theme-text-color--disabled": tokens.colorNeutralLightest,
          },
          // bgs always turn to black
          bg: {
              '--theme-color-brand-primary-darkest-bg': fullBlack,
              '--theme-color-brand-primary-dark-bg': fullBlack,
              '--theme-color-brand-primary-medium-bg': fullBlack,
              '--theme-color-brand-secondary-medium-bg': fullBlack,
              '--theme-color-brand-secondary-darkest-bg': fullBlack,
              '--theme-color-brand-primary-light-bg': fullBlack,
              '--theme-color-brand-primary-lightest-bg': fullBlack,
              '--theme-color-support-success-light-bg': fullBlack,
              '--theme-color-support-success-dark-bg': fullBlack,
              '--theme-color-support-success-medium-bg': fullBlack,
              '--theme-color-support-danger-light-bg': fullBlack,
              '--theme-color-support-danger-medium-bg': fullBlack,
              '--theme-color-support-danger-dark-bg': fullBlack,
              '--theme-color-support-highlight-darkest-bg': fullBlack,
              '--theme-color-support-highlight-dark-bg': fullBlack,
              '--theme-color-support-highlight-lightest-bg': fullBlack,
              '--theme-color-support-highlight-light-bg': fullBlack,
              '--theme-color-support-highlight-medium-bg': fullBlack,
              '--theme-color-neutral-lightest-bg': fullBlack,
              '--theme-color-neutral-light-bg': fullBlack,
              '--theme-color-neutral-medium-bg': fullBlack,
              '--theme-color-neutral-dark-bg': fullBlack,
              '--theme-color-neutral-darkest-bg': fullBlack,
              '--theme-color-global-dark-bg': fullBlack,
              '--theme-color-global-darkest-bg': fullBlack,
              '--theme-color-global-medium-bg': fullBlack,
              '--theme-color-global-light-bg': fullBlack,
              '--theme-color-global-lightest-bg': fullBlack,
              "--theme-accessibility-blue": fullBlack
          },
          // contents always turn to white
          content: {
              '--theme-color-brand-primary-darkest-content': tokens.colorNeutralLightest,
              '--theme-color-brand-primary-dark-content': tokens.colorNeutralLightest,
              '--theme-color-brand-primary-medium-content': tokens.colorNeutralLightest,
              '--theme-color-brand-secondary-medium-content': tokens.colorNeutralLightest,
              '--theme-color-brand-secondary-darkest-content': tokens.colorNeutralLightest,
              '--theme-color-brand-primary-light-content': tokens.colorNeutralLightest,
              '--theme-color-brand-primary-lightest-content': tokens.colorNeutralLightest,
              '--theme-color-support-success-light-content': tokens.colorNeutralLightest,
              '--theme-color-support-success-dark-content': tokens.colorNeutralLightest,
              '--theme-color-support-success-medium-content': tokens.colorNeutralLightest,
              '--theme-color-support-danger-light-content': tokens.colorNeutralLightest,
              '--theme-color-support-danger-medium-content': tokens.colorNeutralLightest,
              '--theme-color-support-danger-dark-content': tokens.colorNeutralLightest,
              '--theme-color-support-highlight-darkest-content': tokens.colorNeutralLightest,
              '--theme-color-support-highlight-dark-content': tokens.colorNeutralLightest,
              '--theme-color-support-highlight-lightest-content': tokens.colorNeutralLightest,
              '--theme-color-support-highlight-light-content': tokens.colorNeutralLightest,
              '--theme-color-support-highlight-medium-content': tokens.colorNeutralLightest,
              '--theme-color-neutral-lightest-content': tokens.colorNeutralLightest,
              '--theme-color-neutral-light-content': tokens.colorNeutralLightest,
              '--theme-color-neutral-medium-content': tokens.colorNeutralLightest,
              '--theme-color-neutral-dark-content': tokens.colorNeutralLightest,
              '--theme-color-neutral-darkest-content': tokens.colorNeutralLightest,
              '--theme-color-global-dark-content': tokens.colorNeutralLightest,
              '--theme-color-global-darkest-content': tokens.colorNeutralLightest,
              '--theme-color-global-medium-content': tokens.colorNeutralLightest,
              '--theme-color-global-light-content': tokens.colorNeutralLightest,
              '--theme-color-global-lightest-content': tokens.colorNeutralLightest,
          },
          // contents always turn to acessibilityYellow
          clickable: {
              '--theme-color-brand-primary-darkest-clickable': acessibilityYellow,
              '--theme-color-brand-primary-dark-clickable': acessibilityYellow,
              '--theme-color-brand-primary-medium-clickable': acessibilityYellow,
              '--theme-color-brand-secondary-medium-clickable': acessibilityYellow,
              '--theme-color-brand-secondary-darkest-clickable': acessibilityYellow,
              '--theme-color-brand-primary-light-clickable': acessibilityYellow,
              '--theme-color-brand-primary-lightest-clickable': acessibilityYellow,
              '--theme-color-support-success-light-clickable': acessibilityYellow,
              '--theme-color-support-success-dark-clickable': acessibilityYellow,
              '--theme-color-support-success-medium-clickable': acessibilityYellow,
              '--theme-color-support-danger-light-clickable': acessibilityYellow,
              '--theme-color-support-danger-medium-clickable': acessibilityYellow,
              '--theme-color-support-danger-dark-clickable': acessibilityYellow,
              '--theme-color-support-highlight-darkest-clickable': acessibilityYellow,
              '--theme-color-support-highlight-dark-clickable': acessibilityYellow,
              '--theme-color-support-highlight-lightest-clickable': acessibilityYellow,
              '--theme-color-support-highlight-light-clickable': acessibilityYellow,
              '--theme-color-support-highlight-medium-clickable': acessibilityYellow,
              '--theme-color-neutral-lightest-clickable': acessibilityYellow,
              '--theme-color-neutral-light-clickable': acessibilityYellow,
              '--theme-color-neutral-medium-clickable': acessibilityYellow,
              '--theme-color-neutral-dark-clickable': acessibilityYellow,
              '--theme-color-neutral-darkest-clickable': acessibilityYellow,
              '--theme-color-global-dark-clickable': acessibilityYellow,
              '--theme-color-global-darkest-clickable': acessibilityYellow,
              '--theme-color-global-medium-clickable': acessibilityYellow,
              '--theme-color-global-light-clickable': acessibilityYellow,
              '--theme-color-global-lightest-clickable': acessibilityYellow,
          },
      },
  },
  components: {
      Skeleton: {
          "--theme-skeleton-color--medium": tokens.colorNeutralDark,
          "--theme-skeleton-color--dark": fullBlack,
      },
      Alert: {
          "--theme-backgroundColor-Alert-success-light": fullBlack,
          "--theme-backgroundColor-Alert-success-dark": fullBlack,
          "--theme-backgroundColor-Alert-danger-light": fullBlack,
          "--theme-backgroundColor-Alert-danger-dark": fullBlack,
          "--theme-textColor-Alert-success-light": tokens.colorNeutralLightest,
          "--theme-textColor-Alert-success-dark": tokens.colorNeutralLightest,
          "--theme-textColor-Alert-danger-light": tokens.colorNeutralLightest,
          "--theme-textColor-Alert-danger-dark": tokens.colorNeutralLightest,
          "--theme-textColor-Alert-button-success-light": acessibilityYellow,
          "--theme-textColor-Alert-button-success-dark": acessibilityYellow,
          "--theme-textColor-Alert-button-danger-light": acessibilityYellow,
          "--theme-textColor-Alert-button-danger-dark": acessibilityYellow,
          "--theme-borderColor-Alert-default": tokens.colorNeutralLightest,
      },
      Button: {
          primary: {
              default: {
                  "--theme-text-decoration-Button": tokens.textUnderline,
                  "--theme-text-decoration-hover-Button": "none",
                  "--theme-background-color-Button--primary": fullBlack,
                  "--theme-text-color-Button--primary": acessibilityYellow,
                  "--theme-border-color-Button--primary": acessibilityYellow,
                  "--theme-background-color-Button-hover--primary": fullBlack,
                  "--theme-text-color-Button-hover--primary": acessibilityYellow,
                  "--theme-border-color-Button-hover--primary": acessibilityYellow,
              },
              inverse: {
                  "--theme-background-color-Button--primary-inverse": fullBlack,
                  "--theme-text-color-Button--primary-inverse": acessibilityYellow,
                  "--theme-border-color-Button--primary-inverse": acessibilityYellow,
                  "--theme-background-color-Button-hover--primary-inverse": fullBlack,
                  "--theme-text-color-Button-hover--primary-inverse": acessibilityYellow,
                  "--theme-border-color-Button-hover--primary-inverse": acessibilityYellow,
              },
          },
          secondary: {
              default: {
                  "--theme-background-color-Button--secondary": fullBlack,
                  "--theme-text-color-Button--secondary": acessibilityYellow,
                  "--theme-border-color-Button--secondary": acessibilityYellow,
                  "--theme-background-color-Button-hover--secondary": fullBlack,
                  "--theme-text-color-Button-hover--secondary": acessibilityYellow,
                  "--theme-border-color-Button-hover--secondary": acessibilityYellow,
              },
              inverse: {
                  "--theme-background-color-Button--secondary-inverse": 'transparent',
                  "--theme-text-color-Button--secondary-inverse": acessibilityYellow,
                  "--theme-border-color-Button--secondary-inverse": acessibilityYellow,
                  "--theme-background-color-Button-hover--secondary-inverse": 'transparent',
                  "--theme-text-color-Button-hover--secondary-inverse": acessibilityYellow,
                  "--theme-border-color-Button-hover--secondary-inverse": acessibilityYellow,
              },
          },
          global: {
              "--theme-background-color-Button--global": fullBlack,
              "--theme-text-color-Button--global": acessibilityYellow,
              "--theme-border-color-Button--global": acessibilityYellow,
              "--theme-background-color-Button-hover--global": fullBlack,
              "--theme-text-color-Button-hover--global": acessibilityYellow,
              "--theme-border-color-Button-hover--global": acessibilityYellow,
          },
      },
      Text: {
          "--theme-text-color-Heading--default": tokens.colorNeutralLightest,
          "--theme-text-color-Heading--inverse": tokens.colorNeutralLightest,
          "--theme-text-color-Subtitle--default": tokens.colorNeutralLightest,
          "--theme-text-color-Subtitle--inverse": tokens.colorNeutralLightest,
          "--theme-text-color-Text--default": tokens.colorNeutralLightest,
          "--theme-text-color-Text--inverse": tokens.colorNeutralLightest,
          "--theme-text-color-Link--default": acessibilityYellow,
          "--theme-text-color-Link--inverse": acessibilityYellow,
          "--theme-text-color-Link--dark": acessibilityYellow,
          "--theme-text-color-Label--default": tokens.colorNeutralLightest,
          "--theme-text-color-Label--inverse": tokens.colorNeutralLightest,
      },
      Tooltip: {
          "--theme-borderColor-Tooltip": tokens.colorNeutralLightest,
          "--theme-borderColor-Tooltip-Content": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Tooltip-arrow": fullBlack,
          "--theme-backgroundColor-Tooltip-arrow-border": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Tooltip-Content-arrow": fullBlack,
          "--theme-backgroundColor-Tooltip-Content-arrow-back": tokens.colorNeutralLightest,
      },
      Checkbox: {
          default: {
              "--theme-borderColor-Checkbox-default": acessibilityYellow,
              "--theme-textColor-Checkbox-default": acessibilityYellow,
              "--theme-borderColor-Checkbox-default--checked": acessibilityYellow,
              "--theme-borderColor-Checkbox-default-check--checked": fullBlack,
              "--theme-backgroundColor-Checkbox-default": fullBlack,
              "--theme-backgroundColor-Checkbox-default--checked": acessibilityYellow,
          },
          inverse: {
              "--theme-borderColor-Checkbox-inverse": acessibilityYellow,
              "--theme-textColor-Checkbox-inverse": acessibilityYellow,
              "--theme-borderColor-Checkbox-inverse--checked": acessibilityYellow,
              "--theme-borderColor-Checkbox-inverse-check--checked": fullBlack,
              "--theme-backgroundColor-Checkbox-inverse": fullBlack,
              "--theme-backgroundColor-Checkbox-inverse--checked": acessibilityYellow,
          },
          darkest: {
              "--theme-borderColor-Checkbox-darkest": acessibilityYellow,
              "--theme-textColor-Checkbox-darkest": acessibilityYellow,
              "--theme-borderColor-Checkbox-darkest--checked": acessibilityYellow,
              "--theme-borderColor-Checkbox-darkest-check--checked": fullBlack,
              "--theme-backgroundColor-Checkbox-darkest": fullBlack,
              "--theme-backgroundColor-Checkbox-darkest--checked": acessibilityYellow,
          },
      },
      CopyContainer: {
          "--theme-backgroundColor-CopyContainer": fullBlack,
          "--theme-color-CopyContainer": "transparent",
          "--theme-borderColor-CopyContainer": acessibilityYellow,
          "--theme-color-CopyContainer-icon": acessibilityYellow,

      },
      Radio: {
          default: {
              "--theme-borderColor-Radio-default": acessibilityYellow,
              "--theme-textColor-Radio-default": acessibilityYellow,
              "--theme-borderColor-Radio-default--checked": acessibilityYellow,
              "--theme-borderColor-Radio-default-check--checked": fullBlack,
              "--theme-backgroundColor-Radio-default": fullBlack,
              "--theme-backgroundColor-Radio-default--checked": acessibilityYellow,
              "--theme-background-color-Radio-circle--default": fullBlack
          },
          inverse: {
              "--theme-borderColor-Radio-inverse": acessibilityYellow,
              "--theme-textColor-Radio-inverse": acessibilityYellow,
              "--theme-borderColor-Radio-inverse--checked": acessibilityYellow,
              "--theme-borderColor-Radio-inverse-check--checked": fullBlack,
              "--theme-backgroundColor-Radio-inverse": fullBlack,
              "--theme-backgroundColor-Radio-inverse--checked": fullBlack,
          },
          darkest: {
              "--theme-borderColor-Radio-darkest": acessibilityYellow,
              "--theme-textColor-Radio-darkest": acessibilityYellow,
              "--theme-borderColor-Radio-darkest--checked": acessibilityYellow,
              "--theme-borderColor-Radio-darkest-check--checked": fullBlack,
              "--theme-backgroundColor-Radio-darkest": fullBlack,
              "--theme-backgroundColor-Radio-darkest--checked": fullBlack,
          },
      },
      ProgressBar: {
          "--theme-backgroundColor-ProgressBar-value-fill--default": tokens.colorNeutralLightest,
      },
      Tag: {
          "--theme-text-color-Label--dark": tokens.colorNeutralLightest,
          "--theme-text-color-Label--darkest": tokens.colorNeutralLightest,
          "--theme-text-color-Label--hat": tokens.colorNeutralLightest,
          "--theme-text-color-Label--highlight": tokens.colorNeutralLightest,
          "--theme-text-color-Label--feedback": tokens.colorNeutralLightest,
          "--theme-text-color-Label--feedbackInverse": tokens.colorNeutralLightest,
      },
      Breadcrumb: {
          "--theme-text-color-Breadcrumb--medium": acessibilityYellow,
          "--theme-text-color-Breadcrumb--darkest": acessibilityYellow,
          "--theme-text-color-Breadcrumb-icon": tokens.colorNeutralLightest,
          "--theme-text-decoration-Breadcrumb-link": tokens.textUnderline,
          "--theme-text-color-BreadcrumbLink--default": acessibilityYellow,
          "--theme-text-color-BreadcrumbIcon--default": tokens.colorNeutralLightest,
          "--theme-text-color-BreadcrumbLink--hover": acessibilityYellow
      },
      Accordion: {
          "--theme-borderColor-Accordion-default": tokens.colorNeutralLightest,
          "--theme-borderColor-Accordion-body-default": fullBlack,
          "--theme-backgroundColor-Accordion-header-default": acessibilityYellow,
          "--theme-backgroundColor-Accordion-body-default": fullBlack,
          "--theme-color-Accordion-toggle-default": fullBlack,
          "--theme-color-Accordion-icon-default": fullBlack
      },
      Banner: {
          "--theme-backgroundColor-Shape-transparent": fullBlack,
          "--theme-backgroundColor-Swiper-pagination-bullet-default": acessibilityYellow,
          "--theme-backgroundColor-Swiper-pagination-bullet-active": tokens.colorNeutralLightest,
      },
      Avatar: {
          "--theme-background-Avatar-color--light": acessibilityYellow,
          "--theme-Color-Avatar-icon": fullBlack,
          "--theme-borderWidth-Avatar-default": tokens.borderWidthThin,
          "--theme-borderColor-Avatar-default": acessibilityYellow,
          "--theme-borderColor-Avatar-notification-default": acessibilityYellow,
      },
      Card: {
          "--theme-borderWidth-Card-default": tokens.borderWidthThin,
          "--theme-borderColor-CardInstitutional-inverse": tokens.colorNeutralLightest,
      },
      Link: {
          "--theme-textDecoration-Link-arrow-default": 'underline',
          "--theme-color-Link-arrow-icon-default": acessibilityYellow,
          "--theme-color-Link-arrow-icon-inverse": acessibilityYellow,
      },
      Modal: {
          "--theme-background-color-Modal-default": fullBlack,
          "--theme-border-color-Modal-default": tokens.colorNeutralLightest,
          "--theme-borderColor-modal": tokens.colorNeutralLightest
      },
      LinkList: {
          "--theme-color-LinkList-default": acessibilityYellow,
          "--theme-color-LinkList-inverse": acessibilityYellow,
      },
      Price: {
          "--theme-color-Price-default": tokens.colorNeutralLightest,
          "--theme-color-Price-value-default": tokens.colorNeutralLightest,
          "--theme-color-Price-inverse": tokens.colorNeutralLightest,
      },
      Header: {
          "--theme-color-Header-logoSvg-inverse": "brightness(100)",
          "--theme-backgroundColor-Header-default": fullBlack,
          "--theme-backgroundColor-Header-inverse": fullBlack,
          "--theme-borderBottomWidth-Header-default": tokens.borderWidthThin,
          "--theme-borderBottomColor-Header-default": tokens.colorNeutralLightest,
      },
      Progress: {
          "--theme-borderWidth-Progress-default": tokens.borderWidthThin,
          "--theme-borderColor-Progress-default": tokens.colorNeutralLightest,
      },
      Rating: {
          "--theme-color-Rating-default": acessibilityYellow,
          "--theme-color-Rating-read-only-default": tokens.colorNeutralLightest,
      },
      Shortcut: {
          "--theme-borderWidth-Shortcut-default": tokens.borderWidthThin,
          "--theme-borderColor-Shortcut-default-hover": tokens.colorNeutralDark,
          "--theme-borderColor-Shortcut-default": acessibilityYellow,
          "--theme-borderColor-Shortcut-inverse": acessibilityYellow,
          "--theme-color-Shortcut-icon-default": acessibilityYellow,
          "--theme-color-Shortcut-icon-inverse": acessibilityYellow,
          "--theme-color-Shortcut-text-default": acessibilityYellow,
          "--theme-color-Shortcut-text-inverse": acessibilityYellow,
      },
      Slider: {
          "--theme-backgroundColor-Slider-default": fullBlack,
          "--theme-backgroundColor-Slider-bar-default": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Slider-bar-progress": acessibilityYellow,
          "--theme-backgroundColor-Slider-thumb-default": acessibilityYellow,
          "--theme-backgroundColor-Slider-thumb-hover": acessibilityYellow,
      },
      Spinner: {
          "--theme-color-Spinner-default": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Spinner-default": fullBlack,
          "--theme-color-Spinner-inverse": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Spinner-inverse": fullBlack,
      },
      Steps: {
          "--theme-color-Steps-icon": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Steps--checked": fullBlack,
          "--theme-backgroundColor-Steps--active": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Steps--doing": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Steps-bar": tokens.colorNeutralLight,
          "--theme-borderColor-Steps": tokens.colorNeutralLightest,
          "--theme-borderColor-Steps--disabled": tokens.colorNeutralMedium,
          "--theme-backgroundColor-Steps--disabled": tokens.colorNeutralMedium,
          "--theme-backgroundColor-Steps--disabledRgba": '212, 215, 222',
      },
      Topic: {
          "--theme-backgroundColor-Topic-icon-default": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Topic-icon-inverse": tokens.colorNeutralLightest,
          "--theme-color-Topic--default": tokens.colorNeutralLightest,
          "--theme-color-Topic-horizontal-icon-default": tokens.colorNeutralLightest,
          "--theme-color-Topic-horizontal-icon-inverse": tokens.colorNeutralLightest,
          "--theme-color-Topic-icon-default": fullBlack,
          "--theme-color-Topic-icon-inverse": fullBlack,
          "--theme-color-Topic-icon-number-default": tokens.colorNeutralLightest,
          "--theme-color-Topic-icon-number-inverse": tokens.colorNeutralLightest,
          "--theme-color-Topic-text-default": tokens.colorNeutralLightest,
          "--theme-color-Topic-text-inverse": tokens.colorNeutralLightest,
      },
      Input: {
          "--theme-borderColor-Input--hover": tokens.colorNeutralLightest,
          "--theme-borderColor-Input": tokens.colorNeutralLightest,
          "--theme-borderColor-Input--disabled": tokens.colorNeutralLightest,
          "--theme-color-Input--disabled": tokens.colorNeutralMedium,
          "--theme-color-Input-label": tokens.colorNeutralLightest,
          "--theme-color-Input-label--disabled": tokens.colorNeutralDark,
          "--theme-color-Input--activated": tokens.colorNeutralLightest,
          "--theme-color-Input-action--activated": acessibilityYellow,
          "--theme-backgroundColor-Input-action--default": acessibilityYellow,
          "--theme-backgroundColor-Input-action--hover": acessibilityYellow,
          "--theme-borderColor-Input-action--hover": acessibilityYellow,
          "--theme-color-Input-action--search": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Input-action--attention": tokens.colorNeutralLightest,
          "--theme-color-Input-action--default": fullBlack,
          "--theme-color-Input-action--hover": fullBlack,
          "--theme-color-Input--attention": tokens.colorNeutralLightest,
          "--theme-color-Input--attentionInverse": tokens.colorNeutralLightest,
          "--theme-color-Input-select-custom-hover-option": tokens.colorNeutralDark,
          "--theme-color-Input-action-date": "invert(1)",
          "--theme-color-Input-action-date--inverse": "invert(1)",
      },
      TabSelect: {
          "--theme-color-link-TabSelect-default": acessibilityYellow,
          "--theme-borderColor-link-TabSelect-default": acessibilityYellow,
          "--theme-color-link-active-TabSelect-default": acessibilityYellow,
          "--theme-color-link-hover-TabSelect-default": acessibilityYellow,
          "--theme-color-link-TabSelect-inverse": acessibilityYellow,
          "--theme-borderColor-link-TabSelect-inverse": acessibilityYellow,
          "--theme-color-link-active-TabSelect-inverse": acessibilityYellow,
          "--theme-color-link-hover-TabSelect-inverse": acessibilityYellow,
      },
      Menu: {
          "--theme-backgroundColor-Menu-top": fullBlack, //black
          "--theme-linkColor-Menu-top": acessibilityYellow, //yellow
          "--theme-backgroundColor-Menu-default": fullBlack, //black
          "--theme-toggleColor-Menu-default": acessibilityYellow, //yellow
          "--theme-backgroundColor-Menu-list": fullBlack, //black
          "--theme-linkColor-Menu-list": acessibilityYellow, //yellow
          "--theme-linkColor-Menu-list-desk": acessibilityYellow, //yellow
          "--theme-borderColor-Menu": tokens.colorNeutralLightest, //white
          "--theme-borderColor-Menu-desk": tokens.colorNeutralLightest, //white
          "--theme-borderColor-Menu-top": tokens.colorNeutralLightest, //white
          "--theme-borderColor-Menu-notification-item": tokens.colorNeutralLightest, //white
          "--theme-borderColor-Menu-contracts": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Menu-contracts-hover": fullBlack, //black
          "--theme-borderColor-Menu-arrow": tokens.colorNeutralLightest,
          "--theme-borderColor-Menu-shortcut": tokens.colorNeutralLightest, //white
          "--theme-linkColor-Menu-shortcut": acessibilityYellow, //yellow
          "--theme-backgroundColor-Menu-shortcut": fullBlack, //black
          "--theme-backgroundColor-Menu-active": fullBlack, //black
          "--theme-textDecoration-Menu": 'underline',
          "--theme-backgroundColor-Menu-top-item-focus": fullBlack,
      },
      Calendar: {
          "--theme-background-Calendar-day": tokens.colorNeutralLightest,
          "--theme-background-Calendar": fullBlack,
          "--theme-borderColor-Calendar-day": acessibilityYellow,
          "--theme-borderColor-Calendar-day--hover": acessibilityYellow,
          "--theme-textColor-Calendar-default": tokens.colorNeutralLightest,
          "--theme-textColor-Calendar-inverse": tokens.colorNeutralLightest,
          "--theme-textColor-Calendar-link-default": acessibilityYellow,
          "--theme-textColor-Calendar-link-inverse": acessibilityYellow,
          "--theme-textColor-Calendar-link--hover": acessibilityYellow,
          "--theme-textColor-Calendar-link--readOnly": tokens.colorNeutralLightest,
          "--theme-textDecoration-Calendar-anchor--hover": tokens.textUnderline,
      },
      Toggle: {
          "--theme-backgroundColor-Toggle-default": fullBlack,
          "--theme-borderColor-Toggle-default": acessibilityYellow,
          "--theme-backgroundColor-circle-Toggle-default": acessibilityYellow,
          "--theme-backgroundColor-active-Toggle-default": acessibilityYellow,
          "--theme-backgroundColor-circle-active-Toggle-default": fullBlack,
          "--theme-backgroundColor-Toggle-inverse": fullBlack,
          "--theme-borderColor-Toggle-inverse": 'transparent',
          "--theme-backgroundColor-circle-Toggle-inverse": acessibilityYellow,
          "--theme-backgroundColor-circle-active-Toggle-inverse": fullBlack,
          "--theme-backgroundColor-active-Toggle-inverse": acessibilityYellow,
          "--theme-backgroundColor-Toggle-attention": tokens.colorSupportHighlightLight,
          "--theme-backgroundColor-circle-Toggle-attention": fullBlack,
          "--theme-backgroundColor-Toggle-inverse-attention": tokens.colorSupportHighlightLight,
          "--theme-backgroundColor-circle-Toggle-inverse-attention": fullBlack,
          "--theme-backgroundColor-Toggle-darkest": fullBlack,
          "--theme-backgroundColor-circle-Toggle-darkest": acessibilityYellow,
          "--theme-backgroundColor-circle-active-Toggle-darkest": fullBlack,
          "--theme-backgroundColor-active-Toggle-darkest": acessibilityYellow,
          "--theme-backgroundColor-Toggle-darkest-attention": tokens.colorSupportHighlightLight,
          "--theme-backgroundColor-circle-Toggle-darkest-attention": tokens.colorSupportHighlightDark,
      },
      Collpase: {
          "--theme-borderColor-Collapse-default": tokens.colorNeutralLightest,
          "--theme-borderStyle-Collapse-default": tokens.borderStyleDefault,
          "--theme-borderWidth-Collapse-default": tokens.borderWidthThin,
      },
      Swiper: {
          "--theme-borderColor-Swiper-default": tokens.colorNeutralLightest,
          "--theme-borderStyle-Swiper-default": tokens.borderStyleDefault,
          "--theme-borderWidth-Swiper-default": 0,
          "--theme-background-Swiper-bullet-background-default": acessibilityYellow,
          "--theme-background-Swiper-bullet-background-hover": acessibilityYellowHover,
          "--theme-background-Swiper-bullet-icon-default": fullBlack,
          "--theme-background-Swiper-bullet-icon-hover": fullBlack,
          "--theme-background-Swiper-inverse-bullet-background-default": acessibilityYellow,
          "--theme-background-Swiper-inverse-bullet-background-hover": acessibilityYellowHover,
          "--theme-background-Swiper-inverse-bullet-icon-hover": fullBlack,
          "--theme-backgroundColor-bullet-hover": acessibilityYellowHover,
      },
      HelpPassword: {
          "--theme-backgroundColor-HelpPassword-default": fullBlack,
          "--theme-text-color-HelpPassword": tokens.colorNeutralLightest,
          "--theme-borderColor-HelpPassword-default": tokens.colorNeutralLightest,
      },
      Footer: {
          "--theme-borderColor-Footer-default": tokens.colorNeutralLightest,
          "--theme-borderStyle-Footer-default": tokens.borderStyleDefault,
          "--theme-borderWidth-Footer-default": tokens.borderWidthThin,
          "--theme-color-Footer-logoSvg-inverse": "brightness(100)",
          "--theme-backgroundColor-Footer-default": fullBlack,
          "--theme-color-Footer-default": tokens.colorNeutralLightest,
          "--theme-color-icon-Footer-default": acessibilityYellow,
          "--theme-color-icon-Footer-hover-default": acessibilityYellow,
          "--theme-backgroundColor-Footer-secondary": fullBlack,
          "--theme-color-Footer-secondary": tokens.colorNeutralLightest,
          "--theme-color-icon-Footer-secondary": acessibilityYellow,
          "--theme-color-icon-Footer-hover-secondary": acessibilityYellow,
          "--theme-textDecoration-FooterLinks": 'underline',
      },
      BrandGroup: {
          "--theme-textColor-BrandGroup-etc-default": fullBlack,
      },
      IconGroup: {
          "--theme-textColor-IconGroup-plus-default": tokens.colorNeutralLightest,
      },
      Countdown: {
          "--theme-borderColor-Countdown--bar": tokens.colorNeutralLightest,
          "--theme-borderWidth-Countdown--bar": tokens.borderWidthThin,
          "--theme-backgroundColor-Countdown--progress": tokens.colorNeutralLightest,
          "--theme-backgroundColor-Countdown--progress--isOpen": tokens.colorNeutralLightest,
          "--theme-text-color-Countdown--progress": fullBlack,
      },
      Others: {
          "--theme-color-neutral-darkest": fullBlack,
          "--theme-color-neutral-dark": tokens.colorNeutralDark,
          "--theme-color-neutral-medium": tokens.colorNeutralMedium,
          "--theme-color-neutral-light": tokens.colorNeutralLight,
          "--theme-color-neutral-lightest": tokens.colorNeutralLightest,
          "--theme-color-brand-primary-darkest": tokens.colorBrandPrimaryDarkest,
          "--theme-color-brand-primary-dark": tokens.colorBrandPrimaryDark,
          "--theme-color-brand-primary-medium": fullBlack,
          "--theme-color-brand-primary-light": tokens.colorBrandPrimaryLight,
          "--theme-color-brand-primary-lightest": tokens.colorBrandPrimaryLightest,
          "--theme-color-global-dark": tokens.colorGlobalDark,
          "--theme-color-global-darkest": tokens.colorGlobalDarkest,
          "--theme-color-global-medium": tokens.colorGlobalMedium,
          "--theme-color-global-light": tokens.colorGlobalLight,
          "--theme-color-global-lightest": tokens.colorGlobalLightest,
      },
      Typography: {
          "--theme-fontFamily-heading-default": tokens.fontFamilyHighlight,
          "--theme-font-family-text-default": tokens.fontFamilyBase,
      },
  }
};

export default contrast;
export { contrastBody };
